import _ from 'lodash'

import routeParams from 'helpers/routeParams'

const GET_TASKS_ACTIVITY_APPROVAL =
  'dofe-bo/activityApprovalTasks/GET_TASKS_ACTIVITY_APPROVAL'
const GET_TASKS_ACTIVITY_APPROVAL_SUCCESS =
  'dofe-bo/activityApprovalTasks/GET_TASKS_ACTIVITY_APPROVAL_SUCCESS'
const GET_TASKS_ACTIVITY_APPROVAL_FAIL =
  'dofe-bo/activityApprovalTasks/GET_TASKS_ACTIVITY_APPROVAL_FAIL'
const GET_PHYSICAL_TASKS = 'dofe-bo/activityApprovalTasks/GET_PHYSICAL_TASKS'
const GET_PHYSICAL_TASKS_SUCCESS =
  'dofe-bo/activityApprovalTasks/GET_PHYSICAL_TASKS_SUCCESS'
const GET_PHYSICAL_TASKS_FAIL =
  'dofe-bo/activityApprovalTasks/GET_PHYSICAL_TASKS_FAIL'
const GET_SKILLS_TASKS = 'dofe-bo/activityApprovalTasks/GET_SKILLS_TASKS'
const GET_SKILLS_TASKS_SUCCESS =
  'dofe-bo/activityApprovalTasks/GET_SKILLS_TASKS_SUCCESS'
const GET_SKILLS_TASKS_FAIL =
  'dofe-bo/activityApprovalTasks/GET_SKILLS_TASKS_FAIL'
const GET_SERVICE_TASKS = 'dofe-bo/activityApprovalTasks/GET_SERVICE_TASKS'
const GET_SERVICE_TASKS_SUCCESS =
  'dofe-bo/activityApprovalTasks/GET_SERVICE_TASKS_SUCCESS'
const GET_SERVICE_TASKS_FAIL =
  'dofe-bo/activityApprovalTasks/GET_SERVICE_TASKS_FAIL'
const SET_FILTER = 'dofe-bo/activityApprovalTasks/SET_FILTER'
const SET_BASE_FILTER = 'dofe-bo/activityApprovalTasks/SET_BASE_FILTER'
const SET_PARAMS = 'dofe-bo/activityApprovalTasks/SET_PARAMS'
const SET_DISABLED_CACHE = 'dofe-bo/activityApprovalTasks/SET_DISABLED_CACHE'
const REMOVE_DETAIL_DATA = 'dofe-bo/activityApprovalTasks/REMOVE_DETAIL_DATA'
const SET_SECTION_PARAMS = 'dofe-bo/activityApprovalTasks/SET_SECTION_PARAMS'

const initialState = {
  list: [],
  detail: {},
  sort: '',
  offset: 0,
  limit: 10,
  pages: 1,
  count: null,
  filter: '',
  invalidate: null,
  loading: false,
  loaded: false,
  physical: {
    list: [],
    loading: false,
    sort: ''
  },
  skills: {
    list: [],
    loading: false,
    sort: ''
  },
  service: {
    list: [],
    loading: false,
    sort: ''
  }
}

export default function reducer(state = initialState, action = {}) {
  let newState = {}

  switch (action.type) {
    case GET_TASKS_ACTIVITY_APPROVAL:
      newState = {
        ...state,
        loading: true
      }

      if (action.decoFilter) {
        newState = {
          ...newState,
          [action.decoFilter]: {
            ...state[action.decoFilter],
            loading: true
          }
        }
      }
      return newState
    case GET_TASKS_ACTIVITY_APPROVAL_SUCCESS:
      newState = {
        ...state,
        loading: false,
        loaded: true,
        list: action.result,
        count: action.headers['x-total-count'],
        pages:
          Math.ceil(Number(action.headers['x-total-count']) / state.limit) ||
          state.pages
      }

      if (action.decoFilter) {
        newState = {
          ...newState,
          [action.decoFilter]: {
            ...state[action.decoFilter],
            list: action.result,
            loading: false
          }
        }
      }

      return newState
    case GET_TASKS_ACTIVITY_APPROVAL_FAIL:
      newState = {
        ...state,
        loading: false
      }

      if (action.decoFilter) {
        newState = {
          ...newState,
          [action.decoFilter]: {
            ...state[action.decoFilter],
            loading: false
          }
        }
      }
      return newState
    case GET_PHYSICAL_TASKS:
      return {
        ...state,
        physical: {
          ...state.physical,
          loading: true
        }
      }
    case GET_PHYSICAL_TASKS_SUCCESS:
      return {
        ...state,
        physical: {
          ...state.physical,
          list: action.result,
          loading: false
        }
      }
    case GET_PHYSICAL_TASKS_FAIL:
      return {
        ...state,
        physical: {
          ...state.physical,
          loading: false
        }
      }
    case GET_SKILLS_TASKS:
      return {
        ...state,
        skills: {
          ...state.skills,
          loading: true
        }
      }
    case GET_SKILLS_TASKS_SUCCESS:
      return {
        ...state,
        skills: {
          ...state.skills,
          list: action.result,
          loading: false
        }
      }
    case GET_SKILLS_TASKS_FAIL:
      return {
        ...state,
        skills: {
          ...state.skills,
          loading: false
        }
      }
    case GET_SERVICE_TASKS:
      return {
        ...state,
        service: {
          ...state.service,
          loading: true
        }
      }
    case GET_SERVICE_TASKS_SUCCESS:
      return {
        ...state,
        service: {
          ...state.service,
          list: action.result,
          loading: false
        }
      }
    case GET_SERVICE_TASKS_FAIL:
      return {
        ...state,
        service: {
          ...state.service,
          loading: false
        }
      }
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy,
        invalidate: new Date().getTime()
      })
    case SET_BASE_FILTER:
      return Object.assign({}, state, {
        baseFilter: action.filterBy,
        invalidate: new Date().getTime()
      })
    case SET_PARAMS:
      return {
        ...state,
        limit:
          action.options.limit !== undefined
            ? action.options.limit
            : state.limit,
        offset:
          action.options.offset !== undefined
            ? action.options.offset
            : state.offset,
        filter:
          action.options.filter !== undefined
            ? action.options.filter
            : state.filter,
        sort:
          action.options.sort !== undefined
            ? action.options.sort
            : state.sort,
        invalidate: _.isEmpty(action.options)
          ? state.invalidate
          : new Date().getTime()
      }
    case SET_SECTION_PARAMS:
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          sort: action.options.sort || state[action.section].sort
        }
      }
    case SET_DISABLED_CACHE:
      return Object.assign({}, state, {
        loaded: false
      })
    case REMOVE_DETAIL_DATA:
      return Object.assign({}, state, {
        detail: {}
      })
    default:
      return state
  }
}

export function getTasksActivityApproval(params = {}, baseFilter, decoFilter) {
  const options = {
    disableTotalRow: true
  }

  return {
    types: [
      GET_TASKS_ACTIVITY_APPROVAL,
      GET_TASKS_ACTIVITY_APPROVAL_SUCCESS,
      GET_TASKS_ACTIVITY_APPROVAL_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/activity-approval?with=APPEND_CUSTOMIZATIONS,ASSESSOR,PARTICIPANT_PERSON,ACTIVITY,AWARD,CATEGORY_IN_DESCRIPTION,ACTIVITY_PARENT${routeParams(
          params,
          baseFilter,
          options
        )}`
      ),
    decoFilter
  }
}

export function getPhysicalActivityApprovalTasks(params = {}, baseFilter) {
  return {
    types: [
      GET_PHYSICAL_TASKS,
      GET_PHYSICAL_TASKS_SUCCESS,
      GET_PHYSICAL_TASKS_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/activity-approval-physical-recreation?with=APPEND_CUSTOMIZATIONS,ASSESSOR,PARTICIPANT_PERSON,ACTIVITY,AWARD,CATEGORY_IN_DESCRIPTION,ACTIVITY_PARENT${routeParams(
          params,
          baseFilter
        )}`
      )
  }
}

export function getSkillsActivityApprovalTasks(params = {}, baseFilter) {
  return {
    types: [GET_SKILLS_TASKS, GET_SKILLS_TASKS_SUCCESS, GET_SKILLS_TASKS_FAIL],
    promise: client =>
      client.get(
        `api/tasks/activity-approval-skills?with=APPEND_CUSTOMIZATIONS,ASSESSOR,PARTICIPANT_PERSON,ACTIVITY,AWARD,CATEGORY_IN_DESCRIPTION,ACTIVITY_PARENT${routeParams(
          params,
          baseFilter
        )}`
      )
  }
}

export function getServiceActivityApprovalTasks(params = {}, baseFilter) {
  return {
    types: [
      GET_SERVICE_TASKS,
      GET_SERVICE_TASKS_SUCCESS,
      GET_SERVICE_TASKS_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/activity-approval-service?with=APPEND_CUSTOMIZATIONS,ASSESSOR,PARTICIPANT_PERSON,ACTIVITY,AWARD,CATEGORY_IN_DESCRIPTION,ACTIVITY_PARENT${routeParams(
          params,
          baseFilter
        )}`
      )
  }
}

export function setActivityApprovalFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setActivityApprovalBaseFilter(filterBy) {
  return {
    type: SET_BASE_FILTER,
    filterBy
  }
}

export function removeDetailData() {
  return {
    type: REMOVE_DETAIL_DATA
  }
}

export function setActivityApprovalParams(options) {
  return {
    type: SET_PARAMS,
    options
  }
}

export function setActivityApprovalSectionParams(options, section) {
  return {
    type: SET_SECTION_PARAMS,
    options,
    section
  }
}

export function removeCache() {
  return {
    type: SET_DISABLED_CACHE
  }
}
